export class Mapping {
  name: string;
  mappingId: number;

  constructor(name, type) {
    this.name = name;
    this.mappingId = type;
  }
}
